import { render } from "./HumanResourcesHome.vue?vue&type=template&id=02a47b08&scoped=true"
import script from "./HumanResourcesHome.vue?vue&type=script&lang=js"
export * from "./HumanResourcesHome.vue?vue&type=script&lang=js"

import "./HumanResourcesHome.vue?vue&type=style&index=0&id=02a47b08&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a47b08"]])

export default __exports__